import { BorderColor, TagColor } from '../interface/common';

export enum TransactionFilters {
  open = 'open',
  all = 'all',
}
export enum InvoiceableType {
  BILLABLE = 'billable',
  NON_BILLABLE = 'non-billable',
  INTERNAL = 'internal',
}
export enum TransactionStatus {
  open = 'open',
  nonBillable = 'non-billable',
  reviewed = 'reviewed',
  invoiced = 'invoiced',
  preliminaryInvoice = 'preliminary-invoice',
  approved = 'approved',
  incomplete = 'incomplete',
  upliftdownlift = 'uplift-downlift',
}
export enum TransactionTypeUsage {
  billableMatter = 'billable-matter',
  internalMatter = 'internal-matter',
}
export enum CalculatePrice {
  default = 'default',
  totalPrice = 'total-price',
}
export enum TransactionSections {
  transaction = 'transaction',
  timesheet = 'timesheet',
}
export enum TransactionViewTab {
  general = 'general',
  notes = 'notes',
}
export const tagColorMapping: {
  [key in TransactionStatus]: TagColor;
} = {
  [TransactionStatus.open]: TagColor.GREEN,
  [TransactionStatus.incomplete]: TagColor.RED,
  [TransactionStatus.invoiced]: TagColor.YELLOW,
  [TransactionStatus.nonBillable]: TagColor.DARKGREY,
  [TransactionStatus.preliminaryInvoice]: TagColor.BLUE,
  [TransactionStatus.approved]: TagColor.BEIGE,
  [TransactionStatus.reviewed]: TagColor.LIGHTBLUE,
  [TransactionStatus.upliftdownlift]: TagColor.PURPLE,
};

export const cardBorderColorMapping: {
  [key in TransactionStatus]: string;
} = {
  [TransactionStatus.open]: BorderColor.GREEN,
  [TransactionStatus.incomplete]: BorderColor.RED,
  [TransactionStatus.invoiced]: BorderColor.YELLOW,
  [TransactionStatus.nonBillable]: BorderColor.DARKGREY,
  [TransactionStatus.preliminaryInvoice]: BorderColor.BLUE,
  [TransactionStatus.approved]: BorderColor.BEIGE,
  [TransactionStatus.reviewed]: BorderColor.LIGHTBLUE,
  [TransactionStatus.upliftdownlift]: BorderColor.PURPLE,
};

export enum TransactionUnitPriceSource {
  MANUAL = 'manual',
  NOT_SET = 'not-set',
  MATTER = 'matter',
  MATTER_ROLE = 'matter-role',
  CUSTOMER = 'customer',
  CUSTOMER_CONTACT_ROLE = 'customer-contact-role',
  CUSTOMER_ROLE = 'customer-role',
  USER = 'user',
  USER_ROLE = 'user-role',
  TRANSACTION_TYPE = 'transaction-type',
  MATTER_TRANSACTION_TYPE = 'matter-transaction-type',
  TEAM_MEMBER = 'team_member',
  INTERNAL_MATTER = 'internal_matter',
  SUBSCRIPTION = 'subscription',
  MATTER_SUB_CONTRACT = 'matter-sub-contract',
  PRINCIPAL = 'principal',
  PRINCIPAL_PARENT_CUSTOMER = 'principal-parent-customer',
  MATTER_TEAM_MEMBER = 'matter-team-member',
  PRINCIPAL_TEAM_MEMBER = 'principal-team-member',
  PRINCIPAL_PARENT_CUSTOMER_TEAM_MEMBER = 'principal-parent-customer-team-member',
  PRINCIPAL_ROLE = 'principal-role',
  PRINCIPAL_PARENT_CUSTOMER_ROLE = 'principal-parent-customer-role',
  USER_PRICING_LIST = 'user-pricing-list',
}

export const TRANSACTION_QUERY_KEYS_TO_INVALIDATE = ['transaction-details', 'transactions'];
